import { render } from "./Management.vue?vue&type=template&id=638aa34c&ts=true"
import script from "./Management.vue?vue&type=script&lang=ts"
export * from "./Management.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__